module.exports = __webpack_public_path__ + "img/disconected_icon.57052bf5.svg";